import React, { Component, createContext } from 'react';

export const UserRegistrationContext = createContext({});

export class UserRegistrationContextProvider extends Component{
    updateDisplayForm = (displayFormInput) => {
        this.setState({
            displayForm: displayFormInput
        })
    }

    updateCustomerID = (customerIDInput) => {
        this.setState({
            customerID: customerIDInput
        })
    }

    updateSerialNumber1 = (serialNumber1Input) => {
        this.setState({
            serialNumber1: serialNumber1Input
        })
    }

    updateSerialNumber2 = (serialNumber2Input) => {
        this.setState({
            serialNumber2: serialNumber2Input
        })
    }

    updateZipcode = (zipcodeInput) => {
        this.setState({
            zipcode: zipcodeInput
        })
    }

    updateFirstName = (firstNameInput) => {
        this.setState({
            firstName: firstNameInput
        })
    }

    updateLastName = (lastNameInput) => {
        this.setState({
            lastName: lastNameInput
        })
    }

    updateUserName = (userNameInput) => {
        this.setState({
            userName: userNameInput
        })
    }

    updateUserPassword = (userPasswordInput) => {
        this.setState({
            userPassword: userPasswordInput
        })
    }

    updateRegion = (regionInput) => {
        this.setState({
            region: regionInput
        })
    }

    updatePreviousForm = (previousFormInput) => {
        this.setState({
            previousForm: previousFormInput
        })
    }

    state = {
        displayForm: "",
        customerID: "",
        serialNumber1: "",
        serialNumber2: "",
        zipcode: "",
        firstName: "",
        lastName: "",
        userName: "",
        userPassword: "",
        region: [],
        previousForm: "",
        updateDisplayForm: this.updateDisplayForm,
        updateCustomerID: this.updateCustomerID,
        updateSerialNumber1: this.updateSerialNumber1,
        updateSerialNumber2: this.updateSerialNumber2,
        updateZipcode: this.updateZipcode,
        updateRegion: this.updateRegion,
        updateFirstName: this.updateFirstName,
        updateLastName: this.updateLastName,
        updateUserName: this.updateUserName,
        updateUserPassword: this.updateUserPassword,
        updatePreviousForm: this.updatePreviousForm
    }

    render() {
        return (
            <UserRegistrationContext.Provider value={this.state}>
                {this.props.children}
            </UserRegistrationContext.Provider>
        )
    }
}